import { Button, Checkbox, message } from 'antd';
import { Input } from 'antd';
import './style.scss';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate, Link } from 'react-router-dom';
import { SignInApi } from '../../apis/SignIn';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import useAuthContext from '../../hooks/useAuthContext';
import metaModelLogo from '../../Images/sidebar/Logo_MetaModel.svg';
import { updateStepWiseUserData } from '../../redux/Reducers/userStepsDataDetailReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

const LoginModalPopup = ({
  showLoginModal,
  setShowLoginModal,
  isLoggedInByGenerate,
  setIsLoggedInByGenerate,
  isLoggedInByPricing,
  setIsLoggedInByPricing,
  setShowForgot,
  setShowSignUp
}) => {
  let navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cookies, setCookie] = useCookies(['email', 'password']);
  const [errorMsg, setErrorMsg] = useState('');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const { userState, dispatcher } = useAuthContext();

  const dispatch = useDispatch();
  useEffect(() => {
    if (cookies.__MM__UE && cookies.__MM__UP) {
      setEmail(atob(cookies.__MM__UE));
      setPassword(atob(cookies.__MM__UP)); // Decoding Base64 password
      setRememberMe(true);
    }
  }, [cookies]);

  const currentPath = window.location.pathname;
  

  const googleLogin = useGoogleLogin({
    flow: 'implicit',
    onSuccess: async (credentialResponse) => {
      const response = await SignInApi.getCredsGoogleLogin(credentialResponse);
      let obj = {
        email: response.data.email,
        name: response.data.name,
        distributorId: '663b39b3ab4ec46c6ebcf259',
        accessToken: credentialResponse.access_token,
      };
      
      const userResponse = await SignInApi.userGoogleLogin(obj);
      
      if (userResponse.status === 200) {
        let user = {
          userEmail: obj.email,
          userName: obj.name,
          userToken: userResponse.data.token,
        };
        
        localStorage.setItem('mm:user', JSON.stringify(user));
        localStorage.setItem('metamodel_token', userResponse.data.token);
        dispatcher({
          type: 'LOGIN',
          payload: user,
        });
        setIsLoggedInByPricing(true);
      }
    },
  });

  const handleUserLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      message.error('Please enter all the value');
      return;
    }
    if (!emailRegex.test(email)) {
      setErrorMsg('Please enter correct email');
      return;
    }
    try {
      let payload = {
        email: email,
        password: password,
      };
      const result = await SignInApi.loginUser(payload);
      if (result?.status == 200) {
        if (rememberMe) {
          setCookie('__MM__UE', btoa(email), {
            path: '/',
            secure: true,
            maxAge: 3600,
          });
          setCookie('__MM__UP', btoa(password), {
            path: '/',
            secure: true,
            maxAge: 3600,
          });
        } else {
          setCookie('__MM__UE', '', { path: '/' });
          setCookie('__MM__UP', '', { path: '/' });
        }
        let user = {
          userEmail: email,
          userName: email,
          userToken: result.data.token,
        };
        localStorage.setItem('mm:user', JSON.stringify(user));
        localStorage.setItem('metamodel_token', result.data.token);
        dispatcher({
          type: 'LOGIN',
          payload: user,
        });
        setIsLoggedInByPricing(true);
      }
      if (result?.response?.status == 400) {
        message.error(
          result.response.data.message || 'Please try again later.'
        );
      }
    } catch (err) {
      console.log(err);
      message.error(err.response.data || 'Please try again later.');
    }
  };

  const getGoogleLogin = () => {
    return (
      <div className="google_login_line">
        <Button className="google_login_btn" onClick={googleLogin}>
          {/* <img
            src="./../../Images/google_logo.svg"
            alt="googleIcon"
            className="google_icon"
          /> */}
          <p> Login with Google</p>
        </Button>
      </div>
    );
  };


  const handleForgot = () =>{
    setShowForgot(true);
    setShowLoginModal(false);
    
  }

  const handleSignUp = () =>{
    setShowSignUp(true);
    setShowLoginModal(false);
  }

  const handleNavigate=() =>{
    navigate('/signup');
    setShowLoginModal(false);
  }

  const getLoginForm = () => {
    return (
      <>
        <div className="user_email">
          <Input
            type="email"
            id="email"
            name="email"
            onChange={(e) => {
              setEmail(e.target.value);
              setErrorMsg('');
            }}
            placeholder="Your email"
            required
            className="email_input"
            value={email}
          />
          {errorMsg && <div className="error">{errorMsg}</div>}
        </div>
        <div className="user_password">
          <Input.Password
            placeholder="Enter Password"
            required
            className="password_input"
            name="password"
            onChange={(e) => {
              setPassword(e.target.value);
              console.log(e);
            }}
            onPressEnter={handleUserLogin}
            value={password}
          />
        </div>
        <div className="remember_forgot">
          <Checkbox
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          >
            Remember me
          </Checkbox>
          {/* <Link to="/forgot-password" className="forgot_password">
            Forgot Password?
          </Link> */}
          
          {currentPath === "/subscription" ? '' : <Button className='forgot_password' onClick={handleForgot}>Forgot Password?</Button>}
        </div>
        <div className="continue_btn_line">
          <Button
            className="continue_btn"
            type="submit"
            onClick={handleUserLogin}
          >
            <p> Login </p>
          </Button>
        </div>
      </>
    );
  };
  return (
    <>  
    <div className="login_modal_popup">
     
     <div className="login_wrapper">
     <div className='close' onClick={()=>setShowLoginModal(false)}></div>
        <div className="direction_line_1">Login/Sign up</div>
        <div className="direction_line_2">get 10 free credits</div>
        {getGoogleLogin()}
        <div className="direction_line_3">
          Or login using your email address
        </div>
        {getLoginForm()}
        <div className="direction_line_4">
          New User? {currentPath === '/subscription' ? <Button className="create_account" onClick={handleNavigate}>Create an account</Button> : <Button className="create_account" onClick={handleSignUp}>Create an account</Button>}
        </div>
      </div>
    </div>
    </>

  );
};

export default LoginModalPopup;
